/**
 * Pre-configured Character Presets for classroom stories, science, math, and history.
 */
import { RigColors } from './CharacterRig';

export interface CharacterVoiceConfig {
  gender?: 'male' | 'female' | 'robot';
  pitch?: number;
  rate?: number;
  voiceName?: string;
}

export interface CharacterPresetConfig {
  name: string;
  colors: RigColors;
  accessories: {
    glasses?: boolean;
    labCoat?: boolean;
    crown?: boolean;
    tie?: boolean;
    cap?: boolean;
  };
  voice: CharacterVoiceConfig;
  scale?: number;
}

export const CharacterPresets: Record<string, CharacterPresetConfig> = {
  teacher: {
    name: 'Guru Sir',
    colors: {
      skin: '#fcd34d',
      hair: '#1e293b',
      shirt: '#0284c7', // Professional Blue
      pant: '#1e293b',
      accent: '#fbbf24'
    },
    accessories: {
      glasses: true,
      tie: true
    },
    voice: {
      gender: 'male',
      pitch: 0.9,
      rate: 1.0
    },
    scale: 1.0
  },

  student: {
    name: 'Priya',
    colors: {
      skin: '#fed7aa',
      hair: '#312e81',
      shirt: '#a855f7', // Purple Hoodie
      pant: '#334155',
      accent: '#ec4899'
    },
    accessories: {
      glasses: false
    },
    voice: {
      gender: 'female',
      pitch: 1.25,
      rate: 1.05
    },
    scale: 0.88
  },

  scientist: {
    name: 'Dr. Raman',
    colors: {
      skin: '#fcd34d',
      hair: '#475569',
      shirt: '#0f766e',
      pant: '#1e293b',
      accent: '#14b8a6'
    },
    accessories: {
      glasses: true,
      labCoat: true
    },
    voice: {
      gender: 'male',
      pitch: 0.95,
      rate: 1.0
    },
    scale: 1.02
  },

  king: {
    name: 'King Ashoka',
    colors: {
      skin: '#fcd34d',
      hair: '#0f172a',
      shirt: '#b91c1c', // Royal Crimson
      pant: '#78350f',
      accent: '#fbbf24' // Gold
    },
    accessories: {
      crown: true
    },
    voice: {
      gender: 'male',
      pitch: 0.8,
      rate: 0.95
    },
    scale: 1.08
  },

  robot: {
    name: 'Robi',
    colors: {
      skin: '#94a3b8',
      hair: '#0284c7',
      shirt: '#334155',
      pant: '#1e293b',
      accent: '#06b6d4'
    },
    accessories: {},
    voice: {
      gender: 'robot',
      pitch: 0.55,
      rate: 0.95
    },
    scale: 0.95
  }
};
